import { Monitor, Smartphone } from "lucide-react";

export type Viewport = "desktop" | "mobile";

interface ViewportToggleProps {
  viewport: Viewport;
  onChange: (viewport: Viewport) => void;
}

export function ViewportToggle({ viewport, onChange }: ViewportToggleProps) {
  return (
    <div
      role="group"
      aria-label="Viewport-Vorschau"
      className="inline-flex items-center gap-1 rounded-md border p-0.5"
    >
      <button
        type="button"
        aria-label="Desktop-Ansicht"
        aria-pressed={viewport === "desktop"}
        onClick={() => onChange("desktop")}
        className={
          viewport === "desktop"
            ? "inline-flex items-center gap-1 rounded bg-secondary px-2 py-1 text-xs font-medium"
            : "inline-flex items-center gap-1 rounded bg-transparent px-2 py-1 text-xs text-muted-foreground hover:bg-muted"
        }
      >
        <Monitor className="h-3.5 w-3.5" />
        Desktop
      </button>
      <button
        type="button"
        aria-label="Mobile-Ansicht"
        aria-pressed={viewport === "mobile"}
        onClick={() => onChange("mobile")}
        className={
          viewport === "mobile"
            ? "inline-flex items-center gap-1 rounded bg-secondary px-2 py-1 text-xs font-medium"
            : "inline-flex items-center gap-1 rounded bg-transparent px-2 py-1 text-xs text-muted-foreground hover:bg-muted"
        }
      >
        <Smartphone className="h-3.5 w-3.5" />
        Mobile
      </button>
    </div>
  );
}
